import React from "react";
import Select from "../../../../form/select/Select";

const TextOptions = ({ editor }) => {
  const formattingOptions = [
    { name: "Normal", value: "normal", icon: "format paragraph" },
    { name: "Heading 1", value: 1, icon: "format h1" },
    { name: "Heading 2", value: 2, icon: "format h2" },
    { name: "Heading 3", value: 3, icon: "format h3" },
    { name: "Heading 4", value: 4, icon: "format h4" },
    { name: "Heading 5", value: 5, icon: "format h5" },
    { name: "Heading 6", value: 6, icon: "format h6" },
    { name: "Code Block", value: "codeBlock", icon: "format file-code" },
  ];

  function getActiveFormat() {
    const headingLevel = [1, 2, 3, 4, 5, 6].find((level) =>
      editor.isActive("heading", { level })
    );
    if (headingLevel) return headingLevel;
    if (editor.isActive("paragraph")) return "normal";
    if (editor.isActive("codeBlock")) return "codeBlock";
    return "normal";
  }

  function onChangeHandler(val, data) {
    editor.chain().focus();

    if ([1, 2, 3, 4, 5, 6].includes(val)) {
      editor.chain().toggleHeading({ level: val }).run();
    } else {
      switch (val) {
        case "normal":
          editor.chain().setParagraph().run();
          break;
        case "bulletList":
          editor.chain().toggleBulletList().run();
          break;
        case "orderedList":
          editor.chain().toggleOrderedList().run();
          break;
        case "taskList":
          editor.chain().toggleTaskList().run();
          break;
        case "blockquote":
          editor.chain().toggleBlockquote().run();
          break;
        case "codeBlock":
          editor.chain().toggleCodeBlock().run();
          break;
        default:
          break;
      }
    }
  }

  return (
    <div className="w-32">
      <Select
        dropdownButtonClass={"!h-9 !text-xs !font-medium"}
        dropdownData={formattingOptions}
        checked={false}
        onChange={onChangeHandler}
        selectedValue={getActiveFormat()}
      />
    </div>
  );
};

export default TextOptions;
